import RegisterForm from '@/components/forms/RegisterForm';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Alert } from 'antd';
import { getRedirectRoute } from '@/utils/redirect';
import { getPendingTenantSelectionFlag, clearPendingTenantSelectionFlag } from '@/utils/loginFlow';
import AuthPageShell from '@/components/auth/AuthPageShell';
import { useTranslation } from 'react-i18next';

type RegisterSearch = {
  tenantInviteToken?: string;
};

export const Route = createFileRoute('/register')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return {
      tenantInviteToken: (search.tenantInviteToken as string) || undefined
    };
  },
  beforeLoad: ({ context }) => {
    if (!context?.auth) clearPendingTenantSelectionFlag();
    if (context?.auth && !getPendingTenantSelectionFlag()) {
      const redirectRoute = getRedirectRoute(context.auth);
      throw redirect({
        to: redirectRoute
      });
    }
  }
});

function RouteComponent() {
  const { tenantInviteToken } = Route.useSearch();
  const { t } = useTranslation(['auth', 'common']);
  
  return (
    <AuthPageShell
      title={t('auth:register.title')}
      subtitle={t('auth:register.subtitle')}
      decoration="mirrored"
      showFooter
    >
      {tenantInviteToken && (
        <Alert
          title={t('auth:register.tenantInviteTitle')}
          description={t('auth:register.tenantInviteDescription')}
          type="info"
          showIcon
          style={{ borderRadius: 8 }}
        />
      )}

      <RegisterForm tenantInviteToken={tenantInviteToken} />
    </AuthPageShell>
  );
}
